import moment from "moment"
import React from "react"
import { Col, Dropdown, Row } from "react-bootstrap"
import BootstrapTable, { ColumnDescription } from "react-bootstrap-table-next"
import filterFactory from "react-bootstrap-table2-filter"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, { CSVExport } from "react-bootstrap-table2-toolkit"
// import BootstrapTable from "react-bootstrap-table-next";
import { useTranslation } from "react-i18next"
import { ValueAddedServiceModel } from "../../api/pricing.api"
import { useAppDispatch } from "../../app/hooks"
import { SearchBar } from "../../components/Tables/Columns"
import CustomTotal from "../../components/Tables/CustomTotal"
import pageListRenderer from "../../components/Tables/PageListRenderer"
import sizePerPageOptionRenderer from "../../components/Tables/SizePerPageOptionRenderer"
import { SERVICE_TYPE } from "../../constants/constants"

function ValueAddedServicesTable({
    valueAddedServices,
    valueAddedServiceDetails,
    setValueAddedServiceDetails,
    setShow,
    setErrors
}: {
    valueAddedServices: ValueAddedServiceModel[]
    valueAddedServiceDetails: Record<string, any>
    setValueAddedServiceDetails: Function
    setShow: Function
    setErrors: Function
}) {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()

    function valueAddedServiceUpdatingDate(cell: string) {
        if (cell) return moment(cell).format("DD MMM yyyy")
    }

    const valueAddedServicesColumns = [
        {
            text: t("Last_Updated"),
            dataField: "updated_at",
            formatter: (cell: string, row: Record<string, any>) => {
                return valueAddedServiceUpdatingDate(cell)
            }
        },
        {
            text: t("Warehouse"),
            dataField: "Warehouse.country"
        },
        {
            text: t("Service"),
            dataField: "service"
        },
        {
            text: t("Description"),
            dataField: "description"
        },
        {
            text: t("Min Value"),
            dataField: "min_value",
            formatter: (cell: number, row: Record<string, any>) => {
                return `${cell} $`
            },
            sort: true
        },
        {
            text: t("Rate/Percentage"),
            dataField: "service_value",
            formatter: (cell: number, row: Record<string, any>) => {
                return `${cell} ${row?.service_type === SERVICE_TYPE["0"] ? "$" : "%"}`
            },
            sort: true
        },
        {
            dataField: "",
            text: t("Actions"),
            formatter: (cell: number, row: Record<string, any>) => {
                return (
                    <Dropdown className="actions-menu">
                        <Dropdown.Toggle variant="primary" id="dropdown-basic" size={"sm"} className="py-0">
                            {t("Actions")}
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            {["Edit", "Delete"].map((action) => (
                                <Dropdown.Item
                                    className="py-0"
                                    onClick={() => {
                                        const tempValueAddedServiceDetails = { ...row }
                                        setValueAddedServiceDetails(tempValueAddedServiceDetails)
                                        if (action === "Edit") {
                                            setShow("editOrCreateModal")
                                            setErrors({})
                                        } else {
                                            setShow("deleteConfirmModal")
                                        }
                                    }}>
                                    {action}
                                </Dropdown.Item>
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                )
            }
        }
    ]

    const options = {
        sizePerPage: 50,
        hideSizePerPage: false,
        hidePageListOnlyOnePage: true,
        sizePerPageOptionRenderer,
        showTotal: true,
        pageListRenderer,
        paginationTotalRenderer: CustomTotal
    }

    const { ExportCSVButton } = CSVExport

    return (
        <div className="table-responsive">
            {valueAddedServicesColumns && (
                <ToolkitProvider
                    keyField="id"
                    data={valueAddedServices}
                    columns={valueAddedServicesColumns as ColumnDescription<any, any>[]}
                    search={{ searchFormatted: true }}
                    exportCSV={{
                        fileName: "ValueAddedServicesTable.csv",
                        noAutoBOM: false,
                        exportAll: false,
                        onlyExportFiltered: true
                    }}>
                    {(props) => (
                        <div className="table-container my-4">
                            <Row className="search mx-4 valueAddedServicess-search">
                                <Col xs={12} sm={12} md={12} lg={12} className="d-flex justify-content-end">
                                    <SearchBar {...props.searchProps} />
                                </Col>
                                <Col className="d-none">
                                    {/* <ExportCSVButton {...props.csvProps} id="valueAddedServicesExportButton">
                        Export
                    </ExportCSVButton> */}
                                </Col>
                            </Row>
                            <Row className="table-data my-3">
                                <Col>
                                    <BootstrapTable
                                        {...props.baseProps}
                                        wrapperClasses="table-wrapper my-3 "
                                        headerClasses="header-class"
                                        bordered={false}
                                        noDataIndication={t("No_Record")}
                                        filter={filterFactory()}
                                        rowClasses="custom-table-row"
                                        condensed={true}
                                        pagination={paginationFactory(options)}
                                        sort={{ dataField: "weight", order: "desc" }}
                                    />
                                </Col>
                            </Row>
                        </div>
                    )}
                </ToolkitProvider>
            )}
        </div>
    )
}

export default ValueAddedServicesTable
